module.exports = __webpack_public_path__ + "img/idx-service-wallet.354b182.webp";